// src/components/LayoutArea/Header/Header.tsx
import React from 'react';
import './Header.css';

export function Header(): JSX.Element {
  return (
    <header className="Header">
      <nav className="navbar">
        <div className="navbar-logo">
          <h1>Decibel Meter</h1>
        </div>
        <ul className="navbar-links">
          <li><a href="/">Home</a></li>
          <li><a href="/about">About</a></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
